/**
 * Get appropriate label for property based on host category
 * @param {string} hostCategory - The host category ('vacation_rental', 'boutique_hotel', 'tourism_board')
 * @param {boolean} plural - Whether to return plural form
 * @returns {string} The appropriate label
 */
export const getPropertyLabel = (hostCategory, plural = false) => {
  if (hostCategory === 'tourism_board') {
    return plural ? 'Destinations' : 'Destination';
  }
  return plural ? 'Properties' : 'Property';
};

/**
 * Get lowercase property label for use in sentences
 * @param {string} hostCategory - The host category
 * @param {boolean} plural - Whether to return plural form
 * @returns {string} The appropriate lowercase label
 */
export const getPropertyLabelLower = (hostCategory, plural = false) => {
  return getPropertyLabel(hostCategory, plural).toLowerCase();
};




